import { render, staticRenderFns } from "./AccountOrganisationEdit.vue?vue&type=template&id=36f7fda8&"
import script from "./AccountOrganisationEdit.vue?vue&type=script&lang=ts&"
export * from "./AccountOrganisationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f7fda8')) {
      api.createRecord('36f7fda8', component.options)
    } else {
      api.reload('36f7fda8', component.options)
    }
    module.hot.accept("./AccountOrganisationEdit.vue?vue&type=template&id=36f7fda8&", function () {
      api.rerender('36f7fda8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/organisations/AccountOrganisationEdit.vue"
export default component.exports